import './App.css';
import {useRef, useState, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './Home';

function App() {
  return (
    <Router>
    <div>
      <Routes>
        <Route path="/Astai-app" element={<Home />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
    </Router>
  );

}

export default App;